import { SelectChangeEvent } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../../../config/api";

export const ShipmentData = [
  {
    field: "All",
    filter: "",
  },
  {
    field: "AIR",
    filter: "AIR",
  },
  {
    field: "ROAD",
    filter: "ROAD",
  },
];
export const PaymentData = [
  {
    field: "All",
    filter: "",
  },
  {
    field: "PREPAID",
    filter: "PREPAID",
  },
  {
    field: "COD",
    filter: "COD",
  },
];

export const ServiceData = [
  {
    field: "All",
    filter: "",
  },
  {
    field: "Xpressbess",
    filter: "Xpressbess",
  },
  {
    field: "Delhivery",
    filter: "Delhivery",
  },
  {
    field: "Bluedart",
    filter: "Bluedart",
  },
];

const useDashboardShipmentFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [serviceData, setServiceData] = useState<string[]>();

  useEffect(() => {
    api
      .get("/b2c/vendors/")
      .then((data) => {
        setServiceData(data?.data?.data?.reverse());
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const startDateConstant =
    (searchParams.get("start-date") && dayjs(searchParams.get("start-date"))) ||
    dayjs().subtract(10, "day");
  const endDateConstant =
    (searchParams.get("end-date") && dayjs(searchParams.get("end-date"))) ||
    dayjs();

  const [startDate, setStartDate] = useState<Dayjs | null>(startDateConstant);
  const [endDate, setEndDate] = useState<Dayjs | null>(endDateConstant);

  const paymentModeParams = searchParams.get("payment_mode") || "All";

  const serviceParams = searchParams.get("service") || "All";

  const shipmentParams = searchParams.get("shipment_mode") || "All";

  let indexOfPayment = PaymentData.findIndex(
    (el) => el.field === paymentModeParams
  );
  let indexOfService = serviceData?.findIndex((el) => el === serviceParams);
  let indexOfShipment = ShipmentData.findIndex(
    (el) => el.field === shipmentParams
  );

  indexOfPayment = indexOfPayment === -1 ? 0 : indexOfPayment;
  indexOfService =
    indexOfService === -1 || indexOfService === undefined ? 0 : indexOfService;
  indexOfShipment = indexOfShipment === -1 ? 0 : indexOfShipment;

  const [paymentMode, setPaymentMode] = useState(
    PaymentData[indexOfPayment].field
  );
  const [shipmentMode, setShipmentMode] = useState(
    ShipmentData[indexOfShipment].field
  );
  const [serviceMode, setServiceMode] = useState(serviceData?.[indexOfService]);

  useEffect(() => {
    setServiceMode(serviceData?.[indexOfService ?? 0]);
  }, [indexOfService, serviceData]);

  const handleShipmentChange = (event: SelectChangeEvent<string>) => {
    setShipmentMode(event.target.value);
    searchParams.set("shipment_mode", event.target.value);
    setSearchParams(searchParams);
  };

  const handlePaymentChange = (event: SelectChangeEvent<string>) => {
    setPaymentMode(event.target.value);

    searchParams.set("payment_mode", event.target.value);
    setSearchParams(searchParams);
  };

  const handleDateChange = (time: Dayjs | null, type: string) => {
    const date = time?.format("YYYY-MM-DD") || "";

    if (type === "start") {
      setStartDate(time);
      searchParams.set("start-date", `${date}`);
      setSearchParams(searchParams);
    } else {
      setEndDate(time);
      searchParams.set("end-date", `${date}`);
    }

    setSearchParams(searchParams);
  };

  const handleServiceFilter = (event: SelectChangeEvent<string>) => {
    setServiceMode(event.target.value);
    searchParams.set("service", event.target.value);
    setSearchParams(searchParams);
  };

  return {
    serviceMode,
    indexOfPayment,
    indexOfService,
    indexOfShipment,
    shipmentMode,
    paymentMode,
    startDate,
    endDate,
    handleDateChange,
    handlePaymentChange,
    handleServiceFilter,
    handleShipmentChange,
    serviceData,
  };
};

export default useDashboardShipmentFilter;
